import * as config from "../../config";

export function getDataUrl(values, pageNum, approvedOption) {
  const url = new URL(
    `${config.MAIN_ADDRESS}/great-telepresence/review/get-data`
  );

  const params = Object.keys(values).reduce((params, key) => {
    if (!values[key]) return params;
    const assignValue = values[key];
    if (key === "agent") params.agentId = assignValue.id;
    if (key === "type") params.typeId = assignValue.id;
    if (key === "approvedOption") params.approvedOption = assignValue;
    if (key === "fromDate") params.fromDate = assignValue;
    if (key === "toDate") params.toDate = assignValue;

    return params;
  }, {});
  if (approvedOption) params.approvedOption = approvedOption;

  if (pageNum && typeof pageNum !== "object") params.pageNumber = pageNum;
  url.search = new URLSearchParams(params).toString();
  return url;
}
